module.exports = __webpack_public_path__ + "static/media/close-outline-1.515ecc83.svg";